define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/xml"
], function(declare, EditController, xml) {

	return declare(EditController, {
		/**
		 * @override
		 * Initialize samples form with product
		 */
		onCreatePopup(view) {
			const sample = this.getNode();
			const product = this.m_cache.getPathNode(sample, this._getProductPath());
			view.setProduct(product);
		},

		/**
		 * @override
		 * If editing sample, then add path to get to parent
		 */
		onDependencyPaths(paths) {
			paths.push(this._getProductPath());
		},

		/**
		 * Return path to get from sample to its parent product
		 * @return {string}
		 */
		_getProductPath() {
			return xml.path(xml.ATTR_PARENT, xml.ATTR_PARENT, xml.ATTR_PARENT);
		}
	});
});